import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';

import { ErrorBlock } from '@src/components/ErrorBlock';
import { ErrorImage } from '@src/components/ErrorImage';
import { sendClickGetMoneyButtonEvent } from '@src/helpers/analyticsEvents';
import { isFasReviewer } from '@src/helpers/isFasReviewer';
import { Layout } from 'app/Layout';

import styles from './NotFoundPage.module.scss';

export const NotFoundPage = () => {
  const { asPath } = useRouter();
  const isSpecialNotFoundPage = isFasReviewer(asPath);

  return (
    <Layout>
      <div className={styles.page}>
        <ErrorImage imageSrc="https://www.sravni.ru/f/images/404.png" alt="404 Страница не найдена" />
        {!isSpecialNotFoundPage && (
          <ErrorBlock className={styles.error_block}>
            <p className={styles.text}>Чтобы найти лучшие займы, нажмите на кнопку ниже</p>
            <Link href="/zaimy/">
              <Button
                variant="primary"
                onClick={() => sendClickGetMoneyButtonEvent(`${window.location.origin}/zaimy/`)}
              >
                Подобрать займ
              </Button>
            </Link>
          </ErrorBlock>
        )}
      </div>
    </Layout>
  );
};
